export default function getInstanceCategory(state, instanceId) {
  return state.games.taboo.currentUserFilterPerInstance[instanceId] ?? null;
}
